import { Title } from '~/components/Title'
import { Input } from '~/components/Input'
import { MaskedInput } from '~/components/MaskedInput'
import { Address } from '~/components/Address'

export const Donor = ({ formId }) => {
  return (
    <>
      <div className="flex items-baseline justify-between">
        <Title content="Personal Information" />
        <span>Id:{formId}</span>
      </div>
      <div className="flex flex-wrap justify-start">
        <MaskedInput
          name="phn"
          label="Personal Health Number"
          placeholder="9--- --- ---"
          options={{ blocks: [4, 3, 3] }}
        />
        <MaskedInput
          name="dateOfBirth"
          label="Date of Birth"
          placeholder="YYYY-MM-DD"
          options={{ date: true, datePattern: ['Y', 'm', 'd'], delimiter: '-' }}
        />
        <p className="mb-4 -mt-4 block text-primary-green sm:w-4/5 xl:w-[96%] print:hidden">
          If you do not have a Personal Health Number, please complete a paper form and mail it to
          BC Transplant.
        </p>
        <Input name="firstName" label="First Name" />
        <Input name="lastName" label="Last Name" />
        <Input name="email" label="Email" />
        <MaskedInput
          name="phoneNumber"
          label="Phone Number"
          options={{ phone: true, phoneRegionCode: 'CA' }}
        />
        <Address />
      </div>
    </>
  )
}
